import { render, staticRenderFns } from "./CourtOrderVerificationTask.vue?vue&type=template&id=56863ee2&scoped=true&"
import script from "./CourtOrderVerificationTask.vue?vue&type=script&lang=js&"
export * from "./CourtOrderVerificationTask.vue?vue&type=script&lang=js&"
import style0 from "./CourtOrderVerificationTask.vue?vue&type=style&index=0&id=56863ee2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56863ee2",
  null
  
)

export default component.exports